import { create } from "zustand";

const AUTH_STORAGE_KEYS = [
  "sessionId",
  "initial_token",
  "token",
  "pending_initial_token",
  "pending_token",
];

const INTENDED_RETURN_URL_KEY = "intendedReturnUrl";
const AUTH_SESSION_KEYS = ["postLoginRedirect", INTENDED_RETURN_URL_KEY];

const useAuthStore = create((set) => ({
  initialAuthToken: null,
  authToken: null,
  initialUserData: null,
  userData: null,
  sessionExpired: false,
  authBootstrapStatus: "idle",

  pageTitle: " ",
  documentTitle: " ",

  setInitialAuthToken: (token) => set({ initialAuthToken: token }),
  setAuthToken: (token) => set({ authToken: token }),
  setInitialUserData: (data) => set({ initialUserData: data }),
  setUserData: (data) => set({ userData: data }),
  setSessionExpired: (expired) => set({ sessionExpired: expired }),
  setAuthBootstrapStatus: (status) => set({ authBootstrapStatus: status }),
  setPageTitle: (title) => set({ pageTitle: title }),
  setDocumentTitle: (title) => set({ documentTitle: title }),

  clearSession: ({ keepReturnUrl = false } = {}) => {
    AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
    AUTH_SESSION_KEYS.forEach((key) => {
      if (keepReturnUrl && key === INTENDED_RETURN_URL_KEY) return;
      sessionStorage.removeItem(key);
    });

    set({
      initialAuthToken: null,
      authToken: null,
      initialUserData: null,
      userData: null,
      sessionExpired: false,
      authBootstrapStatus: "unauthenticated",
    });
  },
}));

// ─── Helper hooks (selector-based, only re-render on slice change) ──────────
export const useAuthToken = () => useAuthStore((s) => s.authToken);
export const useUserData = () => useAuthStore((s) => s.userData);
export const useSessionExpired = () => useAuthStore((s) => s.sessionExpired);
export const useAuthBootstrapStatus = () => useAuthStore((s) => s.authBootstrapStatus);
export const useIsAuthenticated = () => useAuthStore((s) => !!s.authToken);

export default useAuthStore;
